<template>
    <b-card no-body class="card-transparent-background my-0">
        <b-card-header class="card-title-garden-help-default " :class="{ 'mt-2 ': type == 'register' }">
            Payment Details {{ payment_method_id }}
        </b-card-header>

        <b-card-body class="py-0 pr-0">
            <b-row>
                <b-col lg="6" md="8">
                    <b-form-group class="form-group-garden-help" label="Payment Card" label-for="card_id" :card_id="card_id"
                        label-class="form-label-garden-help">
                        <v-select :options="cards_list" v-model="card_id" name="card_id" title="card_id"
                            placeholder="Choose card" label="title" :reduce="(item) => item.value" :clearable="true"
                            :multiple="false" required>
                        </v-select>
                        {{ }}
                    </b-form-group>
                </b-col>
                <b-col lg="6" md="4">
                    <img src="@/assets/images/stripe-logo.png"
                        class="d-block stripeLogo payment-logo-garden-help float-end" />
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6" md="8">
                    <b-form-group class="form-group-garden-help" label="" label-class="form-label-garden-help">
                        <p class="error_validation_message_p_gardenhelp" v-if="invalid_payment_method">
                            Please enter the card details
                        </p>
                    </b-form-group>
                </b-col>
            </b-row>

            <StripeComponentUser ref="stripeComponentUserRef" v-if="card_id == 'new'" client_name="GARDENHELP"
                :require_card="true" element_class_base="form-control form-control-garden-help"
                form_group_class="form-group-garden-help" display_label="true" :future_use_card="future_use_card"
                :variant_primary="'garden-help-primary'" :button_submit_class="'btn-garden-help'"
                :alert_btn_class="'btn-garden-help btn-garden-help-primary'" :payment_method_id.sync="_payment_method_id"
                :display_submit_button="false" />


            <b-row class="mt-2" v-if="card_id == 'new'">
                <b-col>
                    <b-form-checkbox class="
                    form-group-checkbox-group form-group-check-garden-help
                    checkbox-terms-garden-help " v-model="future_use_card" name="future_use_card" value="0"
                        unchecked-value="1">
                        <b> Save card for future use </b>
                    </b-form-checkbox>
                </b-col>
            </b-row>

        </b-card-body>
    </b-card>
</template>
<script>
import StripeComponentUser from '../../../components/Payment/StripeComponentUser.vue';

export default {
    name: "SelectPayment",
    components: { StripeComponentUser },
    props: ["type", "cards_list","card_id", "payment_method_id", "invalid_payment_method"],
    data() {
        return {
            // card_id: null,
            future_use_card: 1
        };
    },
    mounted() {
        console.log(this.payment_method_id)
        if (this.payment_method_id != null) {
            this.card_id = this.payment_method_id
        }
    },
    watch: {
        _card_id(newval, oldval) {
            console.log(newval, oldval)
            if (newval == 'new') {
                this._payment_method_id = 'new'
            } else {
                this._payment_method_id = newval
            }
        }, 

    },

    computed: {
        _payment_method_id: {
            get() {
                return this.payment_method_id;
            },
            set(value) {
                this.$emit("update:payment_method_id", value);
            },
        },
        _card_id: {
            get() {
                return this.card_id;
            },
            set(value) {
                this.$emit("update:card_id", value);
            },
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/components/SelectPayment.vue